import { createReactComponent } from '@tabler/icons-react';

export const IconCustomEInvoicing = createReactComponent(
  'outline',
  'customEInvoicing',
  'CustomEInvoicing',
  [
    [
      'path',
      {
        key: 'customEInvoicing-path',
        d: 'M12.333 2.5708L12.2664 5.90413C12.2664 6.12515 12.3542 6.33711 12.5105 6.49339C12.6668 6.64967 12.8787 6.73747 13.0997 6.73747H16.4996M12.333 2.5708H6.49963C6.05761 2.5708 5.63368 2.7464 5.32112 3.05896C5.00856 3.37152 4.83297 3.79544 4.83297 4.23747V15.9041C4.83297 16.3462 5.00856 16.7701 5.32112 17.0826C5.63368 17.3952 6.05761 17.5708 6.49963 17.5708H10.2496M12.333 2.5708L16.4996 6.73747M16.4996 6.73747V10.9041M15.4996 15.9041H13.0662M13.0662 15.9041V13.4041H16.4996M13.0662 15.9041L12.9996 18.4041H16.4996',
      },
    ],
  ]
);
